<img src="/assets/santa-cut.png" alt="Santa" (click)="santaModal()" />
